export default "/images/salesforce.svg?f0a7e919540225a8aedf4cadbb909792";